/** Where the browser remembers the key that opens /hidden. */
export const HIDDEN_KEY_STORAGE = 'bombeo.hiddenKey'

const sha256Hex = async (text: string): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))
  return [...new Uint8Array(digest)].map(byte => byte.toString(16).padStart(2, '0')).join('')
}

/**
 * A key opens /hidden when its SHA-256 (lowercase hex) is the build's
 * VITE_HIDDEN_KEY_SHA256; with no hash configured, no key does. Only the hash
 * ships in the bundle: this hides UI, it does not guard data.
 */
export const isHiddenKey = async (key: string, expectedSha256: string | undefined): Promise<boolean> =>
  !!expectedSha256 && key !== '' && (await sha256Hex(key)) === expectedSha256.trim().toLowerCase()

// Storage can be blocked (private windows, cleared site data): that reads as no key.
export const readHiddenKey = (): string | null => {
  try {
    return localStorage.getItem(HIDDEN_KEY_STORAGE)
  } catch {
    return null
  }
}

export const storeHiddenKey = (key: string): void => {
  try {
    localStorage.setItem(HIDDEN_KEY_STORAGE, key)
  } catch {
    // Not remembered: the next visit needs the key in the URL again.
  }
}
